import React from 'react';
import { MessageBlock } from 'elmo-elements';
import { withoutPermissionsWarning } from 'messages';

export const WithoutPermissionsWarning = () => (
  <MessageBlock>
    <MessageBlock.Header>{withoutPermissionsWarning}</MessageBlock.Header>
  </MessageBlock>
);
